<template>
  <div class="loan-term-field">
    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <label class="af-custom-label">{{
        mortgage
          ? $t("af:mortgage_offers.filter.input.duration.label")
          : $t("af:offers.filter.input.duration.label")
      }}</label>

      <b-field :style='{"maxWidth":"220px"}'>
        <BInputWithValidation
          id="prelimDurationInput"
          :mask="FIELD_MASK.HUF"
          :rules="{ required: true, regex: /^[0-9 ]*$/ }"
          :value="innerValue"
          :show-success="false"
          ref="durationInput"
          @blur="adjustDuration"
        >
        </BInputWithValidation>
        <p class="control">
          <span class="button is-static">{{
            $t("af:offers.filter.input.duration_unit.label")
          }}</span>
        </p>
      </b-field>
    </div>

    <b-field class="af-slider mt-2">
      <div id="termMinus" class="slider-button" @click="decrease">
        <b-icon
          icon-pack="fa"
          icon="minus"
          type="is-grey-dark"
          size="is-small"
        ></b-icon>
      </div>

      <b-slider
        id="termSlider"
        v-model="innerValue"
        class="mb-0"
        type="is-primary"
        rounded
        :tooltip-always="!isBrand(CUSTOM_APPEARANCE.MBH)"
        :min="filterSettings.durationMin"
        :max="filterSettings.durationMax"
        :step="filterSettings.durationStep"
        :custom-formatter="
          (val) => val + ' ' + $t('af:offers.filter.input.duration_unit.label')
        "
        lazy
      >
      </b-slider>

      <div id="termPlus" class="slider-button" @click="increase">
        <b-icon
          icon-pack="fa"
          icon="plus"
          type="is-grey-dark"
          size="is-small"
        ></b-icon>
      </div>
    </b-field>
    <div
      class="is-flex is-justify-content-space-between has-text-grey-icon is-size-7"
    >
      <span>
        Min. {{ filterSettings.durationMin | monify }}
        {{ $t("af:offers.filter.input.duration_unit.label") }}</span
      >
      <span>
        Max. {{ filterSettings.durationMax | monify }}
        {{ $t("af:offers.filter.input.duration_unit.label") }}</span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {CUSTOM_APPEARANCE, FIELD_MASK} from "@/utils/const";
import { isBrand } from "@/utils/util";
import BInputWithValidation from "@/components/BInputWithValidation.vue";
import { editLandingParam } from "../utils/landingParamUtil";

export default {
  name: "TermSlider",
  components: { BInputWithValidation },
  props: ["value", "mortgage"],
  computed: {
    FIELD_MASK() {
      return FIELD_MASK;
    },
    CUSTOM_APPEARANCE() {
      return CUSTOM_APPEARANCE;
    },
    ...mapGetters({
      filterSettings: "filterSettings/get",
    }),
  },
  data() {
    return {
      innerValue: 0,
    };
  },
  watch: {
    value() {
      this.innerValue = this.value;
    },
    innerValue() {
      editLandingParam("term", this.innerValue);
      this.$emit("input", this.innerValue);
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    isBrand,
    decrease() {
      if (
        this.innerValue - this.filterSettings.durationStep >=
        this.filterSettings.durationMin
      ) {
        this.$emit("input", this.innerValue - this.filterSettings.durationStep);
      }
    },
    increase() {
      if (
        this.innerValue + this.filterSettings.durationStep <=
        this.filterSettings.durationMax
      ) {
        this.$emit("input", this.innerValue + this.filterSettings.durationStep);
      }
    },
    adjustDuration(durationInput) {
      durationInput = Number(durationInput);

      if (!isNaN(durationInput)) {
        let adjustedDuration = durationInput;

        if (durationInput % this.filterSettings.durationStep !== 0) {
          adjustedDuration =
            Math.round(durationInput / this.filterSettings.durationStep) *
            this.filterSettings.durationStep;
        }

        if (adjustedDuration < this.filterSettings.durationMin) {
          adjustedDuration = this.filterSettings.durationMin;
        } else if (adjustedDuration > this.filterSettings.durationtMax) {
          adjustedDuration = this.filterSettings.durationMax;
        }

        this.innerValue = adjustedDuration;
        this.$refs.durationInput.forceUpdate(adjustedDuration);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.slider-button {
  border: 1px solid #f3f5f9;
  box-shadow: 0 2px 5px rgba(42, 45, 52, 0.1);
  border-radius: 100px;
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: white;
}

.mbh {
  .slider-button {
    display: none;
  }
}

.help {
  margin-top: 0;
}

@media only screen and (max-width: 792px) {
  .af-slider {
    padding-left: 24px;
    padding-right: 24px;
  }
}
</style>
